<template lang="pug">
  .relative.width-100(v-on-clickaway='closeDropdown')
    label.label.text-normal(v-if='label') {{ `${ label } ${ showRequiredMark ? `${$t('inputs.requiredMark')}` : ''}` }}
    .input-container.row.wrap(:class='{focus: isDropdownOpen, filled: filled && currentValue.length, "error-container": error, small}')
      .tag.row.middle.m-right-1(v-for='tag in value' :key='tag' :class='{white: filled && currentValue.length, small}')
        span.tag-label.dark-gray(:class='{small, "text-normal": !small, "text-small": small}')
          | {{  getOptionName(tag) }}
        button(@click='removeTag(tag)' v-if='!disabled' type='button')
          simple-svg.svg-icon.dark-gray-icon(:filepath='crossIcon' :width='"12px"' :height='"12px"')
      input.custom-tag-input.item-1(
        type='text'
        name='name'
        :disabled='disabled'
        v-model='inputValue'
        autocomplete='off'
        :placeholder='currentValue.length === 0 && placeholder'
        @focus='openDropdown'
        :class='{filled: filled && currentValue.length, small, "text-normal": !small, "text-small": small}'
      )
      img.direction.m-right-1(v-if='!disabled' @click='toggleDropdown' src='@/assets/ic_chevron-down.svg' :class='{ open: isDropdownOpen }' alt='show options')
    .dropdown-container.absolute.width-100.column.start.kimple-scroll(v-if='isDropdownOpen' :class='{small}')
      button.row.middle.space-between.option-container.width-100(
        type='button'
        v-for='option in filteredOptions'
        @click='setTagStatus(option.id)'
        :key='option.id'
      )
        span.black.text-normal
          | {{ option[labelName] }}
        simple-svg.blue-icon(v-if='optionSelected(option[keyName])' :filepath='checkSvg' :width='"18px"' :height='"18px"')
    .row.top.m-top-1(v-if='showError')
      simple-svg.error-icon.red-icon.m4-right-2(:filepath='errorIcon' :width='"16px"' :height='"16px"')
      span.text-small.red
        | {{ errorMessage }}
</template>

<script>
import { mixin as clickaway } from 'vue-clickaway'
import inputsValidationMixin from '@/mixins/inputsValidationMixin'
import errorIcon from '@/assets/ic_stop.svg'

import crossIcon from '@/assets/ic_cross.svg'
import checkSvg from '@/assets/ic_check_base.svg'

export default {
  mixins: [ clickaway, inputsValidationMixin ],
  props: {
    options: { type: Array, required: true },
    keyName: { type: String, required: true },
    labelName: { type: String, required: true },
    value: { type: Array },
    name: { type: String },
    placeholder: { type: String },
    errorMessage: { type: String },
    label: { type: String },
    error: { type: Boolean },
    showRequiredMark: { type: Boolean, default: false },
    maxTags: { type: Number, default: 30 },
    disabled: { type: Boolean },
    filled: { type: Boolean },
    small: { type: Boolean }
  },
  data () {
    return {
      crossIcon,
      errorIcon,
      checkSvg,
      inputValue: '',
      isDropdownOpen: false
    }
  },
  computed: {
    filteredOptions() {
      const lowercaseInput = this.inputValue.toLowerCase()
      return this.options.filter(opt => opt[this.labelName].toLowerCase().includes(lowercaseInput))
    },
    currentValue() {
      return this.value || []
    }
  },
  methods: {
    getOptionName(id) {
      const option = this.options.find(opt => opt[this.keyName] === id)
      return option ? option[this.labelName] : ''
    },
    removeTag(id) {
      this.$emit('change', this.currentValue.filter(opt => opt !== id), this.name)
    },
    setTagStatus(id) {
      if (!this.currentValue.includes(id) && this.currentValue.length < this.maxTags) {
        this.$emit('change', this.currentValue.concat(id), this.name)
      } else this.removeTag(id)
      this.inputValue = ''
    },
    optionSelected(option) {
      return this.currentValue.includes(option)
    },
    openDropdown() {
      this.isDropdownOpen = true
    },
    closeDropdown() {
      this.isDropdownOpen = false
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';
@import 'src/scss/variables/z-indexes';
@import 'src/scss/common/forms';

.label{
  margin-bottom: 8px;
}

.input-container {
  border: 1px solid $gray;
  border-radius: 6px;
  min-height: 40px;
  height: auto;
  padding: 0;
  background-color: $white;
  &.focus{
    border: 2px solid $blue;
  }
  &.small{
    height: auto;
    min-height: 30px;
  }
}

.filled{
  background-color: $lighter-blue;
}

.tag {
  background-color: $light-gray;
  border-radius: 5px;
  height: 30px;
  margin: 4px;
  padding: 4px 15px;
  &.white{
    background-color: $white;
    color: $dark-gray;
  }
  &.small{
    height: 25px;
    margin: 2px;
    padding: 2px 8px;
  }
}

.tag-label {
  margin-right: 15px;
  &.small{
    margin-right: 8px;
  }
}

.svg-icon {
  line-height: 0;
}

.dropdown-container {
  background-color: $white;
  border: 1px solid $light-gray;
  border-radius: 3px;
  box-shadow: 0 2px 8px 0 $shadow-gray;
  margin-top: 5px;
  max-height: 180px;
  overflow-y: auto;
  z-index: $select-options;
  &.small{
    margin-top: 2px;
    padding: 2px 0;
  }
}

.option-container {
  min-height: 40px;
  padding: 0 16px;
  text-align: left;
  &.small{
    min-height: 30px;
  }
  &:hover {
    background-color: $light-gray;
  }
}

.custom-tag-input {
  min-height: initial;
  padding: 0 8px;
  border-radius: 6px;
  &.small{
    padding: 0 6px;
  }
}

.direction{
  cursor: pointer;
  &.open {
    transform: rotate(180deg);
  }
}

.error-container {
  border-color: $red;
}

</style>
